import React from "react";
import { Div, Text, Image } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";

const testimonials = [
  "The guests they bring on know their stuff, and I like that they get into the weeds on actionable advice. They also seem to delve into which metrics are important, how to improve them etc. the hosts also know their stuff! Highly recommend to those in the D2C space.",
  "I’m a newbie in the DTC space. Almost every week this podcast has at least one guest or topic that helps me think about problems differently. Take advantage of the knowledge shared on this podcast.",
  "The guests are amazing! Each episode covers a unique topic. Some will resonate with you more than others but the variety and depth of knowledge keeps me coming back. Keep up the good work guys.",
];

const PodcastHosts = () => {
  return (
    <>
      <Div>
        <Div
          bg="linear-gradient(223.53deg, #E139C2 1.13%, #6F56FF 65.69%, #4C75F2 98.7%)"
          h="13.75rem"
          w="100%"
          pos="relative"
          d={{ xs: "none", md: "flex" }}
        >
          <Div
            bgImg="/images/Jay.png"
            p={{ b: { lg: "30%", xl: "25%" } }}
            w="50%"
            bgSize="contain"
            bgRepeat="no-repeat"
            bgPos="center"
            pos="absolute"
            bottom="0"
            left="-44px"
          ></Div>
          <Div
            bgImg="/images/Ramon.png"
            p={{ b: { lg: "32%", xl: "26%" } }}
            w="50%"
            bgSize="cover"
            bgRepeat="no-repeat"
            bgPos="center"
            pos="absolute"
            bottom="0"
            right="-10px"
          ></Div>
        </Div>
        <WebsiteContainer>
          <CustomContainer>
            <Div
              d={{ md: "flex" }}
              justify="space-around"
              m={{ t: "3.125rem" }}
            >
              <Div m={{ x: "-1.5rem" }} d={{ md: "none" }}>
                <Div
                  bgImg="/images/Jay_Mobile.png"
                  p={{ b: "50%" }}
                  bgSize="cover"
                  bgPos="center"
                  w="100%"
                />
              </Div>
              <Div textAlign="center" maxW="22rem">
                <Text
                  textWeight="bold"
                  textSize={{ xs: "title3", md: "subheader3" }}
                  style={{ lineHeight: "22px" }}
                  m={{ b: "10px", t: { xs: "2.25rem", md: "0" } }}
                >
                  Jay Desai
                </Text>
                <Text
                  textSize={{ xs: "paragraph", md: "subheader5" }}
                  style={{ lineHeight: "24px" }}
                >
                  Jay Desai is a marketer and the host of the DTC POD. His goal
                  is to help founders and marketers stay on top of topics in DTC
                  and learn how to build a better eCommerce business.
                </Text>
              </Div>
              <Div
                textAlign="center"
                maxW="22rem"
                m={{ t: { xs: "5.125rem", md: "0" } }}
              >
                <Div m={{ x: "-1.5rem" }} d={{ md: "none" }}>
                  <Div
                    bgImg="/images/Ramon_Mobile.png"
                    p={{ b: "50%" }}
                    bgSize="cover"
                    bgPos="center"
                    w="100%"
                  />
                </Div>
                <Text
                  textWeight="bold"
                  textSize={{ xs: "title3", md: "subheader3" }}
                  style={{ lineHeight: "22px" }}
                  m={{ b: "10px", t: { xs: "2.25rem", md: "0" } }}
                >
                  Ramon Berrios
                </Text>
                <Text
                  textSize={{ xs: "paragraph", md: "subheader5" }}
                  style={{ lineHeight: "24px" }}
                >
                  Ramon is a lifelong entrepreneur with a brain that doesn’t
                  have an off switch. His curiosity and passion for all things
                  business makes this podcast a must listen for new and
                  experienced entrepreneurs alike.
                </Text>
              </Div>
            </Div>
            <Div className="podcasts-hosts-grid">
              {testimonials.map(content => {
                return (
                  <Div
                    rounded="4px"
                    bg="lightBlack"
                    p={{
                      xs: "2rem .875rem 1.75rem",
                      md: "1.875rem 1.6rem 1.5rem",
                    }}
                  >
                    <Div d="flex" justify="center">
                      {[1, 2, 3, 4, 5].map(() => (
                        <Div>
                          <Image src="/images/star.svg" h="17px" w="17px" />
                        </Div>
                      ))}
                    </Div>
                    <Text
                      m={{ t: "1rem" }}
                      textWeight="500"
                      textSize="15px"
                      style={{ lineHeight: "23px", fontStyle: "italic" }}
                      textAlign="center"
                    >
                      {content}
                    </Text>
                  </Div>
                );
              })}
            </Div>
          </CustomContainer>
        </WebsiteContainer>
      </Div>
    </>
  );
};

export default PodcastHosts;
